const NoPage = () => {
    return (
        <div className="grow border-x-8 border-custom-bg-gray overflow-auto">
            <div className="max-w-3xl px-6 mx-auto flex flex-col left justify-center p-12 gap-y-4">
                <h1 className="text-darkpink dark-pink font-chat-intro-title text-chat-intro-title">
                    Das hat nicht geklappt
                </h1>
                <div className="font-chat-intro text-chat-intro mb-4 pt-8">
                    Wenn diese Seite auftaucht, dann ist irgendetwas schief gelaufen. Das tut uns leid.
                </div>
                <div className="font-chat-intro text-chat-intro mb-4 pt-4">
                    Bitte gehe zurück in Dein Lernmanagement-System (Ilias/studynet) oder in das Portal 18vier8, je
                    nachdem von wo aus Du Dich eingeloggt hast und versuche es erneut.
                </div>
            </div>
        </div>
    );
};

export default NoPage;
